export const CYCLE_TEACHING_TYPE = {
  LOCAL: 'Local',
  EXTERNAL: 'External',
  LOCAL_AND_EXTERNAL: 'LocalAndExternal'
};